<template>
  <div>
    <RouterView :key="$route.fullPath" />
    
    <DraftProfilePopup />
    <ChatWidget />

    <!-- Global Scroll to Top Button -->
    <button
      @click="scrollToTop"
      :class="['scroll-to-top-btn', { 'show': showScrollTop }]"
      title="Cuộn lên đầu trang"
      aria-label="Cuộn lên đầu trang"
    >
      <icon icon="fa-solid fa-arrow-up" />
    </button>
  </div>
</template>

<script>
import DraftProfilePopup from '@/components/popup/DraftProfilePopup.vue';
import ChatWidget from '@/components/chat-widget/ChatWidget.vue';
import { useHead } from '@vueuse/head'

export default {
  name: 'App',
  components: {
    DraftProfilePopup,
    ChatWidget
  },
  data() {
    return {
      showScrollTop: false
    };
  },
  setup() {
    useHead({
      title: 'Lối Đọc - Nền tảng mạng xã hội cho người đọc sách',
      meta: [
        {
          name: 'description',
          content: 'Trải nghiệm hệ thống gợi ý và đánh giá sách thông minh từ cộng đồng yêu văn học. Nơi tìm kiếm cuốn sách tiếp theo phù hợp nhất trên hành trình đọc của bạn.'
        }
      ]
    })
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showScrollTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>